<template>
  <div class="ms-container full-width">
    <div class="contract-time-table">
      <div class="contract-time-table-header">
        <i-button @click="exportTable" type="primary" icon="md-cloud-download">
          Экспорт таблицы
        </i-button>
      </div>
      <time-table-list
        ref="list"
        :projects="[contract]"
        :default-opened="['0']"
      />
    </div>
  </div>
</template>

<script>
import TimeTableList from '@/components/time-table/time-table-list'
import { mainUrl } from '@/config/urls'
import { downloadFile } from '@/utils'

export default {
  components: {
    TimeTableList
  },
  data () {
    return {
      loading: false,
      roadmap: [],
      contract: this.$store.state.contracts.current,
      token: this.$store.state.auth.token
    }
  },
  methods: {
    exportTable () {
      const baseUrl = `page/project?contract_id=${this.contract.id}`
      const url = `${mainUrl}/api/${baseUrl}&format=excel&access_token=${this.token}`

      downloadFile(url)
    }
  }
}
</script>

<style lang="less">
.contract-time-table {
  &-header {
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
